import { redirect, useLocation, useNavigate } from 'react-router-dom';
import { ReactEventHandler, useState } from 'react';
import { get } from '../helper/api';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import signin_side_img_2 from "../assets/images/signin_side_img_2.png";
import ReactSelect from "react-select";
import { AppMainDarkLogo } from '../constant/logo';
import { zohoLogo } from '../constant/icons';
import signin_side_img_1 from '../assets/images/signin_side_img_1.png'
import login_bg_05 from '../assets/images/login_bg_05.jpg'
import AppMainLogo from '../assets/images/logo-dark.png'
import { message } from '../components/toast';
import { useLoaderHelper } from '../helper/loaderHelper';
// import { get, post } from "../../helper/api";
const Organizations = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orgsParam = queryParams.get('organizations');
    const zohoState = queryParams.get('state');
    const zohoCode = queryParams.get('code');
    const zohoTokenSet = queryParams.get('tokenSet');
    const zohoAccountServer = queryParams.get('accounts-server');
    const loginType = queryParams.get('loginType');
    let orgsList = orgsParam ? JSON.parse(decodeURIComponent(orgsParam)) : [];
    if (!Array.isArray(orgsList)) {
        orgsList = orgsList.organizations
    }
    const navigate = useNavigate()
    const [selectedOrg, setSelectedOrg] = useState({ tenantName: '', tenantId: '' });
    const loader = useLoaderHelper()

    const handleChange = (e: any) => {
        setSelectedOrg((prev: any) => ({ ...prev, tenantName: e.target.options[e.target.selectedIndex].text, tenantId: e.target.value }))
    }


    const handleSubmit = async () => {
        // if (!selectedOrg) return;

        try {
            const response: any = await get("/zoho/connect", { "state": zohoState, "tenant": selectedOrg.tenantId, name: selectedOrg.tenantName, "code": zohoCode, "accounts-server": zohoAccountServer, tokenSet: zohoTokenSet, selectedTenant: true, loginType }, loader)
            message(response.status ? "success" : "error", response?.data?.[0]?.message)
            if (response?.data?.[0]?.redirectUrl) {

                const url = new URL(response?.data?.[0]?.redirectUrl);
                const relative = url.pathname + url.search;
                navigate(relative); // ex: "/zoho/login?token=...&userName=...&role=Admin"
            }
            // navigate(response?.data?.[0]?.redirectUrl)
            // Redirect or handle response as needed
            // console.log('Access granted:', "res.data");
        } catch (err) {
            console.error('Error during access request:', err);
        }
    };


    return (
        <div className='login-page theme_01 organization-form'>
            <Row>
                <Col className="login-img">
                    <img
                        className="charecter_img"
                        alt="Sign in"
                        src={login_bg_05}
                    />
                </Col>

                <Col className="login-form">
                    <div className='login-main small-scroll justify-content-center'>
                        <div className='loging-content'>
                            <div className="info-logo">
                                <figure><img src={AppMainLogo}></img></figure>
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="style=stroke"> <g id="arrow-long-right"> <path id="vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M1.94995 12C1.94995 12.4142 2.28574 12.75 2.69995 12.75L21.2 12.75C21.6142 12.75 21.95 12.4142 21.95 12C21.95 11.5858 21.6142 11.25 21.2 11.25L2.69995 11.25C2.28574 11.25 1.94995 11.5858 1.94995 12Z" fill="#e3882b"></path> <path id="vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M14.1696 4.46967C13.8767 4.76256 13.8767 5.23744 14.1696 5.53033L20.4625 11.8232C20.5601 11.9209 20.5601 12.0791 20.4625 12.1768L14.1696 18.4697C13.8767 18.7626 13.8767 19.2374 14.1696 19.5303C14.4625 19.8232 14.9374 19.8232 15.2303 19.5303L21.5232 13.2374C22.2066 12.554 22.2066 11.446 21.5232 10.7626L15.2303 4.46967C14.9374 4.17678 14.4625 4.17678 14.1696 4.46967Z" fill="#e3882b"></path> </g> </g> </g></svg>
                                <figure>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1400">

                                        <path fill="#226eb3" d="M729.54 1024H30c-16.57 0-30-13.43-30-30V739.84c0-55.52 35.28-104.93 87.8-122.96l775.28-266.09C923.44 330.07 964 273.26 964 209.44 964 127.04 896.96 60 814.56 60H60v494.96c0 16.57-13.43 30-30 30s-30-13.43-30-30V30C0 13.43 13.43 0 30 0h784.56C930.05 0 1024 93.95 1024 209.44c0 89.45-56.84 169.06-141.45 198.1L107.28 673.63C79 683.33 60 709.94 60 739.84V964h669.54c62.63 0 121.5-24.39 165.79-68.67C939.61 851.04 964 792.17 964 729.54c0-44.33-12.49-87.56-36.11-125.02-23.39-37.1-56.55-66.79-95.89-85.88-14.91-7.23-21.13-25.18-13.89-40.09 7.23-14.91 25.18-21.13 40.09-13.89 49.42 23.98 91.07 61.28 120.45 107.86 29.68 47.06 45.36 101.36 45.36 157.03 0 78.65-30.63 152.6-86.25 208.22-55.62 55.6-129.57 86.23-208.22 86.23z" opacity=".9"></path>
                                        <path fill="#226eb3" d="M337.52 419.82c-66.17 0-120-53.83-120-120s53.83-120 120-120 120 53.83 120 120-53.83 120-120 120zm0-180c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60zM638.34 843.53c-66.17 0-120-53.83-120-120s53.83-120 120-120 120 53.83 120 120-53.83 120-120 120zm0-180c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60z" opacity=".9"></path>


                                        <text x="512" y="1330" font-family="Arial, sans-serif" font-size="240" fill="#226eb3" font-weight="bold" text-anchor="middle">
                                            Zoho Books
                                        </text>
                                    </svg>

                                </figure>
                            </div>
                            <h2>App wants access to:</h2>
                            <Form className='form-horizontal form-login row'>
                                <div className='form-group p-0'>
                                    <Input
                                        type="select"
                                        id="exampleSelect"
                                        value={selectedOrg.tenantId}
                                        onChange={handleChange/* (e) => handleChange(e) *//* setSelectedOrg((prev) => ({ ...prev, tenantName: e.target.key, tenantId: e.target.value })) */}
                                    >
                                        <option value="">Select an organization</option>
                                        {orgsList.map((org: any) => (
                                            <option key={org.organization_id} value={org.organization_id}>
                                                {org.name}
                                            </option>
                                        ))}
                                    </Input>
                                </div>
                            </Form>
                            <Button
                                color='primary'
                                className='w-100 d-block text-white btn-lg'
                                onClick={handleSubmit}
                                // style={{
                                //     padding: '10px 20px',
                                //     backgroundColor: '#0072CE',
                                //     color: '#fff',
                                //     border: 'none',
                                //     borderRadius: '4px',
                                //     cursor: selectedOrg ? 'pointer' : 'not-allowed',
                                //     opacity: selectedOrg ? 1 : 0.5,
                                // }}
                                disabled={!selectedOrg}
                            >
                                Allow access
                            </Button>


                        </div>

                        {/* <select
                            value={selectedOrg}
                            onChange={(e) => setSelectedOrg(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '16px',
                                borderRadius: '6px',
                                border: '1px solid #ccc',
                            }}
                        >
                            <option value="">Select an organization</option>
                            {orgsList.map((org: any) => (
                                <option key={org.organization_id} value={org.organization_id}>
                                    {org.name}
                                </option>
                            ))}
                        </select> */}

                    </div>
                </Col>
            </Row>


        </div>
    );
};

export default Organizations;
